import React from 'react';

const useServiceLogger = <T = any>(service: T, prefix: string) => {
  React.useEffect(() => {
    const subscription = (service as any).subscribe((state: any) => {
      if (process.env.NODE_ENV === 'development') {
        console.log(prefix, state);
      }
    });

    return subscription.unsubscribe;
  }, [service]); // note: service should never change
};

export default useServiceLogger;
